'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactBootstrap = require('react-bootstrap');
require('./Tooltip.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * Tooltips allow you to provide more information when a user hovers over a link, a button, ...
 */
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, ['children']);
  return _react2.default.createElement(_reactBootstrap.Tooltip, rest, children);
};
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _reactBootstrap.Tooltip.propTypes) : {};
exports.default = Tooltip;